var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgStackMatchM = function SvgImgStackMatchM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.83 38.89h30.34c16.48 0 29.83 13.36 29.83 29.83 0 1.765-.153 3.494-.447 5.175 8.471.153 16.085 3.817 21.447 9.598 5.479-5.907 13.307-9.603 22-9.603 16.57 0 30 13.43 30 30s-13.43 30-30 30c-8.693 0-16.521-3.696-22-9.603-5.479 5.907-13.307 9.603-22 9.603H55c-16.57 0-30-13.43-30-30 0-15.716 12.082-28.608 27.465-29.894A30.012 30.012 0 0 1 52 68.72c0-16.48 13.36-29.83 29.83-29.83Z",
    fill: "url(#img-stack-match-m_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.3 27.89H90.94v80.45h64.36V27.89Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.96 35.83H83v80.45h64.36V55.23h-19.4v-19.4Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.36 55.23h-19.4v-19.4l19.4 19.4ZM113.85 57.97c0-4.85-3.93-8.79-8.78-8.79s-8.78 3.93-8.78 8.79c0 4.86 3.93 8.79 8.78 8.79s8.78-3.93 8.78-8.79Z",
    fill: "#E6EFFD",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.62 77.33H117M95.62 85.88H117M95.62 94.44h10.69",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.02 121.89c13.11 0 23.74-10.63 23.74-23.74 0-13.11-10.63-23.74-23.74-23.74-13.11 0-23.74 10.63-23.74 23.74 0 13.11 10.63 23.74 23.74 23.74Z",
    fill: "#2E6BF5",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.02 114.39c8.97 0 16.24-7.27 16.24-16.24 0-8.97-7.27-16.24-16.24-16.24-8.97 0-16.24 7.27-16.24 16.24 0 8.97 7.27 16.24 16.24 16.24Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.02 104.4c3.45 0 6.25-2.8 6.25-6.25s-2.8-6.25-6.25-6.25-6.25 2.8-6.25 6.25 2.8 6.25 6.25 6.25Z",
    fill: "#2E6BF5",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m151.39 98.15 25.63-25.63",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m175.56 66.54-5.95 5.95 1.49 5.96 5.95-5.96-1.49-5.95Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m183 73.98-5.95 5.95-5.95-1.48 5.95-5.96 5.95 1.49ZM214 40.62c0-7.76-6.28-14.06-14.04-14.06-7.76 0-14.04 6.28-14.04 14.06s6.28 14.06 14.04 14.06c7.76 0 14.04-6.28 14.04-14.06ZM69 96.57c0-7.76-6.28-14.06-14.04-14.06-7.76 0-14.04 6.28-14.04 14.06s6.28 14.06 14.04 14.06c7.76 0 14.04-6.28 14.04-14.06ZM34 49.95c0-7.76-6.28-14.06-14.04-14.06-7.76 0-14.04 6.28-14.04 14.06s6.28 14.06 14.04 14.06c7.76 0 14.04-6.28 14.04-14.06Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.85 87.57c-.69 0-1.39.06-2.07.18-1.83.31-2.17.98-2.17 2.23v1.63h4.35v.54h-5.99c-.64-.01-1.26.2-1.75.6-.5.4-.83.96-.96 1.58a8.07 8.07 0 0 0 0 4.36c.31 1.27 1.04 2.17 2.3 2.17h1.29v-2.17a2.73 2.73 0 0 1 2.71-2.66h4.54c.6 0 1.18-.22 1.62-.62.44-.4.72-.96.77-1.56v-3.88c-.08-.59-.36-1.14-.8-1.54-.44-.41-1-.65-1.6-.69-.75-.12-1.5-.18-2.25-.18l.01.01Zm-2.29 1.31a.815.815 0 0 1 .82.83c0 .22-.09.42-.24.58-.15.15-.36.24-.58.24-.22 0-.42-.09-.58-.24a.825.825 0 0 1-.24-.58.8.8 0 0 1 .24-.59.8.8 0 0 1 .58-.24Z",
    fill: "#007DED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.07 92.16v1.91a2.613 2.613 0 0 1-2.71 2.5h-4.79c-.6.06-1.15.33-1.55.78-.4.44-.62 1.02-.62 1.62v4.09c0 1.2 1.02 1.85 2.17 2.18 1.47.43 3.04.43 4.52 0 1.09-.31 2.17-.95 2.17-2.18v-1.63h-4.29v-.55h6.5c1.26 0 1.74-.88 2.17-2.17a7.21 7.21 0 0 0 0-4.36c-.31-1.2-.91-2.18-2.17-2.18h-1.39l-.01-.01Zm-2.71 10.4a.82.82 0 0 1 .81.81c0 .22-.09.42-.24.58-.15.15-.36.24-.57.25a.803.803 0 0 1-.52-.27.856.856 0 0 1-.21-.55c0-.2.07-.4.21-.55.13-.15.32-.25.52-.27Z",
    fill: "#FAE65B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.96 51.21c.31 0 .62-.09.88-.27.26-.17.46-.42.58-.71.12-.29.15-.61.1-.92-.06-.31-.21-.59-.42-.82-.22-.23-.5-.38-.8-.45-.3-.07-.62-.04-.91.08-.29.12-.54.32-.72.57-.18.26-.28.56-.28.88 0 .21.03.42.11.62s.19.38.34.53c.15.15.32.27.52.36.19.08.4.12.61.12l-.01.01Z",
    fill: "#62D4F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.96 53.26c-1.92.05-3.83-.21-5.66-.77a7.06 7.06 0 0 1-2.26-1.25c-.27-.19-.5-.44-.67-.73-.17-.29-.27-.61-.3-.95 0-1.05 1.13-2.09 3.08-2.77 1.88-.59 3.84-.87 5.81-.83 1.94-.02 3.88.26 5.73.85.82.26 1.59.66 2.26 1.2.25.18.46.41.62.68.15.27.25.57.28.88 0 1.14-1.29 2.21-3.4 2.9-1.78.54-3.63.81-5.49.79Zm0-6.52c-1.88-.03-3.75.25-5.55.82-1.78.62-2.58 1.47-2.58 2.05 0 .58.86 1.52 2.74 2.17 1.75.53 3.57.77 5.39.73 1.79.03 3.57-.22 5.29-.73a6.74 6.74 0 0 0 2.15-1.14c.18-.12.34-.28.46-.46s.2-.39.23-.6c-.03-.2-.1-.4-.22-.57-.11-.17-.26-.32-.43-.43a6.39 6.39 0 0 0-2-1.05c-1.77-.55-3.62-.82-5.48-.78v-.01Z",
    fill: "#62D4F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 57.57c-.29 0-.58-.07-.84-.22-.92-.53-1.21-2.07-.85-4.07.42-1.93 1.15-3.79 2.16-5.48.94-1.71 2.16-3.25 3.59-4.57.63-.57 1.36-1.03 2.15-1.36.28-.14.6-.21.91-.21.31 0 .63.07.91.21.95.55 1.26 2.29.82 4.38-.44 1.83-1.15 3.58-2.11 5.2-.91 1.7-2.08 3.24-3.48 4.57-.66.61-1.43 1.08-2.26 1.41-.33.1-.67.15-1.01.15l.01-.01Zm1.13-9.39a18.33 18.33 0 0 0-2.05 5.26c-.37 1.85 0 2.99.45 3.27.45.27 1.74 0 3.24-1.29 1.33-1.26 2.45-2.73 3.32-4.34.92-1.53 1.61-3.19 2.05-4.92.18-.8.22-1.62.11-2.43 0-.22-.06-.44-.16-.64s-.24-.37-.41-.51c-.18-.08-.37-.12-.57-.12-.2 0-.39.04-.57.12-.73.3-1.4.74-1.98 1.29-1.37 1.25-2.52 2.7-3.43 4.32v-.01Z",
    fill: "#62D4F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.36 57.47a5.212 5.212 0 0 1-3.09-1.51 18.553 18.553 0 0 1-3.65-4.57 18.245 18.245 0 0 1-2.15-5.46c-.18-.84-.22-1.71-.1-2.56.03-.32.12-.62.28-.89.16-.27.37-.51.63-.69.95-.55 2.55 0 4.19 1.47 1.35 1.3 2.49 2.79 3.4 4.43 1 1.64 1.74 3.44 2.19 5.31.19.87.22 1.76.09 2.64a2.27 2.27 0 0 1-.95 1.63c-.25.14-.54.2-.83.19l-.01.01Zm-6.08-6.51c.92 1.65 2.1 3.14 3.49 4.42 1.46 1.25 2.59 1.51 3.03 1.22.44-.29.88-1.52.5-3.43-.42-1.8-1.12-3.53-2.07-5.11-.87-1.56-1.98-2.98-3.27-4.2a6.954 6.954 0 0 0-2.03-1.36c-.2-.09-.42-.13-.63-.13-.21 0-.43.04-.63.13a1.48 1.48 0 0 0-.54 1.06c-.1.76-.07 1.54.1 2.29.41 1.8 1.1 3.52 2.05 5.11h.01-.01Z",
    fill: "#62D4F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.16 41.28c0 1.34.96 2.12 2.49 1.75v-3.51c-1.56-.47-2.48.5-2.49 1.75v.01Z",
    fill: "#173E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M199.96 30.62c-5.52 0-10 4.47-10 10s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10Zm2.07 3.82h2.1v2.22h-2.1v-2.22Zm-6.6 9.87c-1.79-1.01-1.92-4.21-.51-5.65.71-.72 2.16-1.22 3.7-.9v-3.17c.02-.08 0-.14.06-.15h2.1v10.11c-2.01.34-3.96.55-5.35-.24Zm8.71-6.51v4.61c-.09 1.89-.06 3.37-.75 4.27-.14.18-.41.44-.65.61-.2.15-.59.46-.79.48-.23 0-.79-.31-1.04-.43-.34-.15-.64-.37-.99-.48.8-.5 1.56-.89 1.89-1.9.27-.89.24-2.16.24-3.42v-3.75h2.09v.01Z",
    fill: "#173E2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-stack-match-m_svg__a",
    x1: 25,
    y1: 107,
    x2: 215,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D8FF"
  })))));
};
export default SvgImgStackMatchM;